import { render, staticRenderFns } from "./ContactTypeCreate.vue?vue&type=template&id=01678193"
import script from "./ContactTypeCreate.vue?vue&type=script&lang=js"
export * from "./ContactTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports